export default __webpack_public_path__ + "static/media/vip-4.a6a94ce7.webp";